<template lang="html">
  <router-link v-if="to" :to="to" class="button btn" type="button" :class="classes">
    <span>
      {{label}}
      <slot></slot>
    </span>
  </router-link>
  <button v-else-if="nolink" class="button btn" type="button" :class="classes">
    <span>
      {{label}}
      <slot></slot>
    </span>
  </button>
  <a v-else href="" class="button btn" type="button" :class="classes">
    <span>
      {{label}}
      <slot></slot>
    </span>
  </a>
</template>

<script>
export default {
  props: ['label', 'classes', 'to', 'icon', 'nolink', 'name']
}
</script>

<style lang="scss">
@import './src/assets/scss/variaveis.scss';

.btn[class*="btn"] {
  /*padding: 0;*/
  position: relative;
  overflow: hidden;
  /*border: 0;*/

  &:not(.disabled) {
    cursor: pointer;
  }

  & > .btn-inner {
    position: relative;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    z-index: 2;
  }

  i {
    font-size: 22px;
    margin-right: 5px;
  }

  &.btn-sm {
    & > .btn-inner {
      height: 34px;
      padding: 0 12px;
    }
  }

  &.btn-green {
    background-color: #69e278;
    color: white;
  }
  &.btn-gray {
    background-color: #ddd;
    color: #333;
  }
  &.btn-orange {
    background-color: #ffc107;
    color: white;
  }
  &.btn-flag {
    background-color: #fff;
    color: #666;
    border-style: solid;
    border-width: 1px;

    &.active {
      color: #fff;
    }
  }
  &.btn-flag-blue   {
    border-color: #5BD1F9;
    color: #5BD1F9;
    &.active {
      background: #5BD1F9;
    }
  }
  &.btn-flag-red    {
    border-color: #EF6A57;
    color: #EF6A57;
    &.active {
      background: #EF6A57;
    }
  }
  &.btn-flag-green  {
    border-color: #6FE25E;
    color: #6FE25E;
    &.active {
      background: #6FE25E;
    }
  }
  &.btn-flag-yellow {
    border-color: #F9D35B;
    color: #F9D35B;
    &.active {
      background: #F9D35B;
    }
  }
  &.btn-flag-purple {
    border-color: #AD5AEF;
    color: #AD5AEF;
    &.active {
      background: #AD5AEF;
    }
  }

  &.btn-facebook, &.btn-facebook:hover, &.btn-facebook:focus, &.btn-facebook:active {
    text-decoration: none;
    background-color: rgb(59, 89, 153);
    color: white;
    // box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 6px -1px;
  }

  &.btn-whatsapp, &.btn-whatsapp:hover, &.btn-whatsapp:focus, &.btn-whatsapp:active {
    text-decoration: none;
    background-color: rgb(24, 157, 14);
    color: white;
    // box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 6px -1px;
  }

  &.btn-item {
    display: flex;
    width: 100%;
    margin-bottom: 8px;
    color: #333;
    transition: .8s;
    .btn-inner {
      display: flex;
      width: 100%;
      padding: 0;
      .item {
        width: 100%;
        margin: 0;
      }
    }

    &:hover {
      background-color: #eee;
    }
  }

  &:after {
    content: "";
    transition: 0s;
    position: absolute;
    background-color: rgba(0,0,0,.2);
    width: 100%;
    padding-top: 100%;
    z-index: 1;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0,0);
    z-index: 1;
  }
  &.btn-primary:focus, &.btn-primary:active  {
    color: #fff;
  }
  &:hover:not(.disabled) {
    &:after {
      transition: .8s;
      transform: translate(-50%, -50%) scale(1.05,1.05);
      opacity: 0;
    }
  }
  &:active {
    // color: #fff;
    box-shadow: 0 4px 6px 1px rgba(0,0,0,.2) inset;
    &:after {
      transition: .2s;
      transform: translate(-50%, -50%) scale(1.05,1.05);
      opacity: 1;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/partial/button/Button.vue